import { render, staticRenderFns } from "./ProfitShareReport.vue?vue&type=template&id=12b542fc"
import script from "./ProfitShareReport.vue?vue&type=script&lang=js"
export * from "./ProfitShareReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b542fc')) {
      api.createRecord('12b542fc', component.options)
    } else {
      api.reload('12b542fc', component.options)
    }
    module.hot.accept("./ProfitShareReport.vue?vue&type=template&id=12b542fc", function () {
      api.rerender('12b542fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/ProfitShareReport.vue"
export default component.exports